export default {
  'goldkid-advantageAB:title': 'C Kaspi Gold для ребенка',
  'goldkid-advantageAB-parent:title': 'Родитель сможет',
  'goldkid-advantageAB-parent:advantage-1': 'Переводить ребенку деньги на&nbsp;карманные расходы без комиссии',
  'goldkid-advantageAB-parent:advantage-1-img-alt': 'Переводить ребенку деньги на карманные расходы без комиссии',
  'goldkid-advantageAB-parent:advantage-2': 'Видеть выписку по карте ребенка в&nbsp;своем приложении Kaspi.kz',
  'goldkid-advantageAB-parent:advantage-2-img-alt': 'Видеть выписку по карте ребенка в своем приложении Kaspi.kz',
  'goldkid-advantageAB-parent:advantage-3': 'Управлять доступом на покупки в&nbsp;интернете по карте ребенка',
  'goldkid-advantageAB-parent:advantage-3-img-alt': 'Управлять доступом на покупки в интернете по карте ребенка',
  'goldkid-advantageAB-child:title': 'Ребенок сможет',
  'goldkid-advantageAB-child:advantage-1': 'Пользоваться приложением Kaspi.kz',
  'goldkid-advantageAB-child:advantage-1-img-alt': 'Пользоваться <br> приложением Kaspi.kz',
  'goldkid-advantageAB-child:advantage-2': 'Оплачивать покупки картой <br> и с Kaspi QR',
  'goldkid-advantageAB-child:advantage-2-img-alt': 'Оплачивать покупки картой <br> и с Kaspi QR',
  'goldkid-advantageAB-child:advantage-2-desc': 'Ребенку больше не нужны наличные деньги',
  'goldkid-advantageAB-child:advantage-3': 'Совершать переводы и платежи',
  'goldkid-advantageAB-child:advantage-3-img-alt': 'Совершать переводы и платежи',
  'goldkid-advantageAB-child:advantage-4': 'Накапливать до 5 000 Kaspi <br> Бонусов ежемесячно',
  'goldkid-advantageAB-child:advantage-4-img-alt': 'Накапливать до 5 000 Kaspi <br> Бонусов ежемесячно'
}
